import React, { useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import Filter from "../../../components/basics/Filter";
import DefaultTable from "../../../components/grid/TableDefault";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import SelectConsultaErp from "../../../components/basics/SelectConsultaErp";
import { findSubGrupo } from "../../../repository/components/estoque/EstoqueService";
import SelectErp from "../../../components/basics/SelectErp";
import useMarketPlacesController from "./MarketplacesController";
import CircularProgressWithLabel from "../../../components/basics/CircularProgressErp";
import {
  useGrupos,
  useFabricantes,
  useEstoques,
  useGruposLoading,
  useFabricantesLoading,
  useEstoquesLoading,
  useMarketplace,
  useCnpj,
} from "../../../context/integracao/MarketplacesContext";

import "./Marketplaces.css";

const MarketplacesTabProdutos = ({ ...props }) => {
  sessionStorage.removeItem("tabIndex");

  const { cnpj } = useCnpj();
  const { grupos } = useGrupos();
  const { fabricantes } = useFabricantes();
  const { estoques } = useEstoques();
  const { gruposLoading } = useGruposLoading();
  const { fabricantesLoading } = useFabricantesLoading();
  const { estoquesLoading } = useEstoquesLoading();
  const { marketplace } = useMarketplace();

  // Filtros
  const [codigo, setCodigo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [grupo, setGrupo] = useState(null);
  const [subgrupo, setSubgrupo] = useState(null);
  const [subgrupoHidden, setSubgrupoHidden] = useState(true);
  const [fabricante, setFabricante] = useState(null);
  const [estoque, setEstoque] = useState(null);
  const [loadingTable, setLoadingTable] = useState(false);
  const anunciosOptionList = [
    { id: 0, descricao: "Todos" },
    { id: 1, descricao: "Somente sincronizados" },
    { id: 2, descricao: "Somente não sincronizados" },
  ];
  const [anuncio, setAnuncio] = useState(anunciosOptionList[0]);
  const [produtos, setProdutos] = useState([]);
  const [produtoVincular, setProdutoVincular] = useState();
  const [ativarVincular, setAtivarVincular] = useState(false);
  const [grupoProdutosVincular, setGrupoProdutosVincular] = useState([]);
  const [quantidadeItensTotal, setQuantidadeItensTotal] = useState();
  const [selected, setSelected] = useState([]);
  const [marketplaceDescricao, setMarketplaceDescricao] = useState("");

  // Produtos selecionados no grid
  const colorRed = "#e04854";
  const colorBackgroundItemJaAnunciado = "#b6e7d2";
  const rowId = "estoque_id";
  const SweetAlertReact = withReactContent(Swal);
  const rowsPerPage = 10;
  const quantidadePorPesquisa = 100;

  // Adiciona as funções vindas do MarketPlacesController
  const {
    atualizarProdutos,
    excluirAnuncios,
    pesquisar,
    sincronizarProdutos,
    buscarProdutosNaoVinculados,
    vincularAnuncio,
  } = useMarketPlacesController();

  useEffect(() => {
    setMarketplaceDescricao(marketplace ? marketplace.descricao : "");
  }, [marketplace]);

  useEffect(() => {
    if (ativarVincular)
      SweetAlertReact.fire({
        title: `Vincular produto "${selected[0].descricao}" no ${marketplace.descricao}`,
        showClass: {
          popup: "swal2-noanimation",
          backdrop: "swal2-noanimation",
        },
        html: (
          <SelectErp
            key="produto_marketplace_vincular"
            label="Produto no marketplace"
            value={produtoVincular}
            getOptionLabel={(option) => {
              return `${option.marketplace_produto_id} - ${option.titulo}`;
            }}
            optionsList={grupoProdutosVincular}
            onChange={(valor) => {
              setProdutoVincular(valor);
            }}
          />
        ),
        confirmButtonText: "Vincular",
        showConfirmButton: true,
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        width: "50vw",
      }).then((result) => {
        if (result.isConfirmed) {
          vincularAnuncio(cnpj, marketplace, selected[0], produtoVincular);

          Swal.fire({
            icon: "success",
            text: "O anúncio foi vinculado com sucesso!",
            showConfirmButton: false,
            timer: 3000,
          });

          // Espera o anuncio ser criado no marketplace, para atualizar os itens (2 seg)
          setTimeout(() => {
            pesquisarItens();
          }, 3000);
        }
        setAtivarVincular(false);
        setProdutoVincular(null);
      });
    // eslint-disable-next-line
  }, [produtoVincular, ativarVincular]);

  useEffect(() => {
    if (!loadingTable) {
      Swal.close();
      return;
    }

    Swal.fire({
      title: "Aguarde...",
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: () => false,
    });
  }, [loadingTable]);

  // function dos botões
  const func_btn_excluir_anuncio = async (e) => {
    // Confirmação
    Swal.fire({
      title: `Confirma a exclusão dos anúncios no ${marketplace.descricao}?`,
      confirmButtonText: `Sim`,
      showDenyButton: true,
      denyButtonText: `Não`,
    }).then(async (result) => {
      // Caso não seja confirmado, retorna
      if (!result.isConfirmed) return;

      let produtosExcluir = selected.map((produto) => produto.estoque_id);

      let promisses = await excluirAnuncios(
        cnpj,
        marketplace.id,
        produtosExcluir
      );
      await Promise.all(promisses)
        .then((valores) => {
          Swal.fire({
            icon: "success",
            text: "Os anúncios foram excluídos com sucesso!",
            showConfirmButton: false,
            timer: 3000,
          });
          return valores;
        })
        .catch((erro) => {
          Swal.fire({
            icon: "error",
            html: erro.mensagem,
          });
          return erro;
        });

      // Espera o anuncio ser criado no marketplace, para atualizar os itens (2 seg)
      setTimeout(function () {
        pesquisarItens();
      }, 2000);
    });
  };

  async function pesquisarItens() {
    setLoadingTable(true);
    setSelected([]);

    // Await faz com que a função espere para continuar
    const itens = await pesquisar(
      cnpj,
      codigo,
      descricao,
      grupo,
      subgrupo,
      estoque,
      marketplace,
      fabricante,
      anuncio,
      1,
      quantidadePorPesquisa,
      colorBackgroundItemJaAnunciado
    );

    setProdutos(itens.produtos);

    setQuantidadeItensTotal(itens.total);

    let produtosVincular = await buscarProdutosNaoVinculados(cnpj, marketplace);
    setGrupoProdutosVincular(produtosVincular.data);
    setLoadingTable(false);
  }

  const func_btn_pesquisar = async () => {
    Swal.fire({
      icon: "question",
      title: "Dica",
      text: "Só traremos produtos ativos, de revenda e com foto",
      showConfirmButton: false,
      timer: 3000,
    });
    await pesquisarItens();
  };

  const func_btn_sincronizar = async (e) => {
    let continuar = true;
    // Verifica se não tem nenhum já sincronizado
    selected.forEach((produto) => {
      if (produto.marketplace_produto_id) {
        Swal.fire({
          icon: "error",
          text: "Não é possível sincronizar produtos já sincronizados",
          // showConfirmButton: false,
          // timer: 3000,
        });
        continuar = false;
        return;
      }
    });

    if (!continuar) return;

    setLoadingTable(true);
    setSelected([]);

    let produtosSincronizar = selected.map((produto) => {
      return {
        estoque_id: produto.estoque_id,
        descricao: produto.descricao,
        preco: produto.preco,
        quantidade: produto.quantidade,
        especificacoes_tecnica: produto.especificacoes_tecnica,
        fotos: produto.imagens,
        fabricante: produto.fabricante,
        unidade: produto.unidade,
        peso: produto.peso,
        altura: produto.altura,
        comprimento: produto.comprimento,
        largura: produto.largura,
        tributacao: produto.tributacao,
        cest: produto.cest,
        codigobarras: produto.codigobarras,
      };
    });

    let value = await sincronizarProdutos(
      cnpj,
      marketplace.id,
      produtosSincronizar
    );

    if (value.success && value.mensagem && value.mensagem.dados) {
      if (value.mensagem.dados[0].dados_fiscais_enviados)
        Swal.fire({
          icon: "success",
          text: "Os anúncios foram atualizados com sucesso!",
          showConfirmButton: false,
          timer: 3000,
        });
      else
        Swal.fire({
          icon: "warning",
          text: value.mensagem.dados[0].dados_fiscais_mensagem,
          showConfirmButton: true,
        });

      // Espera o anuncio ser criado no marketplace, para atualizar os itens (2 seg)
      setTimeout(function () {
        pesquisarItens();
      }, 3000);
    } else {
      Swal.fire({
        icon: "error",
        html: value.mensagem,
      });
    }

    setLoadingTable(false);
  };

  const customHandleChancePage = async (event, page, itemIndex) => {
    setLoadingTable(true);

    let pageCarregar = Math.round(itemIndex / quantidadePorPesquisa + 1);

    // Faz uma consulta dos próximos itens
    const itens = await pesquisar(
      cnpj,
      codigo,
      descricao,
      grupo,
      subgrupo,
      estoque,
      marketplace,
      fabricante,
      anuncio,
      pageCarregar,
      quantidadePorPesquisa,
      colorBackgroundItemJaAnunciado
    );
    setLoadingTable(false);
    return itens.produtos;
  };

  const func_btn_atualizar = async (e) => {
    let produtoNaoSincronizado = null;

    let produtosSincronizar = selected.map((produto) => {
      if (!produto.marketplace_produto_id) produtoNaoSincronizado = produto;
      return {
        estoque_id: produto.estoque_id,
        preco: produto.preco,
        quantidade: produto.quantidade,
        tributacao: produto.tributacao,
        cest: produto.cest,
        codigobarras: produto.codigobarras,
      };
    });

    if (produtoNaoSincronizado) {
      Swal.fire({
        icon: "warning",
        text: `O item "${produtoNaoSincronizado.descricao}" ainda não foi sincronizado. Por favor, sincronize antes de atualizar.`,
        showConfirmButton: true,
      });
      return;
    }

    setLoadingTable(true);
    setSelected([]);

    let value = await atualizarProdutos(
      cnpj,
      marketplace.id,
      produtosSincronizar
    );

    if (value.success) {
      if (
        value.mensagem.dados &&
        value.mensagem.dados[0] &&
        value.mensagem.dados[0].dados_fiscais_enviados
      )
        Swal.fire({
          icon: "success",
          text: "Os anúncios foram atualizados com sucesso!",
          showConfirmButton: false,
          timer: 3000,
        });
      else
        Swal.fire({
          icon: "warning",
          text: value.mensagem.dados[0].dados_fiscais_mensagem,
          showConfirmButton: true,
        });
    } else
      Swal.fire({
        icon: "error",
        html: value.mensagem,
      });
    setLoadingTable(false);
  };

  // Abaixo será feito somente a construção da tela
  const inputsFilter = [];
  inputsFilter.push(
    {
      component: (
        <TextFieldErp
          key="marketplace"
          lg={3}
          label="Marketplace"
          value={marketplaceDescricao}
          onChange={() => {}}
          // getOptionSelected={(option, value) => option.id === value.id}
          disabled={true}
        />
      ),
    },
    {
      component: (
        <TextFieldErp
          key="codigo"
          label="Código"
          lg={2}
          value={codigo}
          setValue={setCodigo}
        ></TextFieldErp>
      ),
    },
    {
      component: (
        <TextFieldErp
          key="descricao"
          label="Descrição"
          lg={4}
          value={descricao}
          setValue={setDescricao}
        />
      ),
    },
    {
      component: (
        <SelectErp
          key="fabricante"
          lg={3}
          label="Fabricante"
          value={fabricante}
          setValue={setFabricante}
          optionsList={fabricantes}
          descriptionField="descricao"
          loading={fabricantesLoading}
          // getOptionSelected={(option, value) => option.id === value.id}
        />
      ),
    },
    {
      component: (
        <SelectErp
          key="grupo"
          lg={3}
          label="Grupo"
          value={grupo}
          // setValue={setGrupo}
          onChange={(value) => {
            setSubgrupo(null);
            setSubgrupoHidden(value === null);
            setGrupo(value);
          }}
          optionsList={grupos}
          descriptionField="descricao"
          loading={gruposLoading}
          // getOptionSelected={(option, value) => option.id === value.id}
        />
      ),
    }
  );

  if (!subgrupoHidden) {
    inputsFilter.push({
      component: (
        <SelectConsultaErp
          key="subGrupo"
          label="Subgrupo"
          lg={2}
          value={subgrupo}
          setValue={setSubgrupo}
          finder={() => {
            return findSubGrupo(cnpj, grupo ? grupo.id : "0");
          }}
          onChangeUseEffect={[grupo]}
          descriptionField="descricao"
        />
      ),
    });
  }

  inputsFilter.push(
    {
      component: (
        <SelectErp
          key="estoque"
          label="Estoque"
          lg={2}
          value={estoque}
          setValue={setEstoque}
          optionsList={estoques}
          descriptionField="descricao"
          loading={estoquesLoading}
        ></SelectErp>
      ),
    },
    {
      component: (
        <SelectErp
          key="anuncios"
          label="Anúncios"
          lg={3}
          optionsList={anunciosOptionList}
          descriptionField="descricao"
          value={anuncio}
          // Caso selecione null, a opção vira "Todos"
          onChange={(value) =>
            setAnuncio(value ? value : anunciosOptionList[0])
          }
        ></SelectErp>
      ),
    },
    {
      component: (
        <Button
          key="btn_pesquisar"
          lg={1}
          color="primary"
          variant="contained"
          style={{ height: "100%", width: "100%", minWidth: "8em" }}
          onClick={func_btn_pesquisar}
        >
          Pesquisar
        </Button>
      ),
    }
  );

  // id (nome do campo que será buscado nas rows para colocar o campo no local correto)
  const defaultTableColumns = [
    {
      id: "produto_id",
      label: "Código",
    },
    {
      id: "descricao",
      label: "Descrição",
      format: (value) => {
        return value.url_visualizar ? (
          <Tooltip
            title={"Clique no item para ver o seu anúncio no marketplace."}
            aria-label={"Clique no item para ver o seu anúncio no marketplace."}
          >
            <a href={value.url_visualizar} target="_blank" rel="noreferrer">
              {value.descricao}
            </a>
          </Tooltip>
        ) : (
          value.descricao
        );
      },
    },
    { id: "grupo", label: "Grupo" },
    { id: "local_estoque", label: "Estoque" },
    {
      id: "preco",
      label: "Preço",
      numeric: true,
      format: (value) =>
        // É necessário converter para number antes de usar toLocaleString
        Number(value.preco).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
    },
    {
      id: "quantidade",
      label: "Quantidade",
      numeric: true,
      format: (value) =>
        Number(value.quantidade).toLocaleString("pt-BR", {
          maximumFractionDigits: 2,
        }),
    },
    {
      id: "qualidade",
      label: "Qualidade",
      align: "center",
      description:
        "Indicador de Qualidade. Objetivos criados pelo MarketPlace para melhorar o seu anuncio e alcançar mais clientes.",
      format: (value) => {
        return value.qualidade ? (
          <Tooltip
            title={
              "Indicador de Qualidade. Clique para acessar os objetivos criados pelo MarketPlace para melhorar o seu anuncio e alcançar mais clientes."
            }
            aria-label={
              "Indicador de Qualidade. Clique para acessar os objetivos criados pelo MarketPlace para melhorar o seu anuncio e alcançar mais clientes."
            }
          >
            <a href={value.url_editar} target="_blank" rel="noreferrer">
              <CircularProgressWithLabel
                value={Math.round(value.qualidade * 100)}
              ></CircularProgressWithLabel>
            </a>
          </Tooltip>
        ) : null;
      },
    },
  ];

  let vincularProdutoDisable = true;

  if (selected.length === 1)
    vincularProdutoDisable = selected[0].marketplace_produto_id ? true : false;

  return (
    <>
      <Filter inputs={inputsFilter} key="filter" />
      <div className="margin-10">
        {/* Grid que está colocando a tabela ao lado dos botões */}
        <Grid container spacing={2}>
          <Grid item md={10} xs={12}>
            <label className="desc-label margin-10">
              Para executar as ações, selecione um produto
            </label>
            <DefaultTable
              key="tableAnuncios"
              loading={loadingTable}
              selectable={true}
              selected={selected}
              setSelected={setSelected}
              columns={defaultTableColumns}
              tableTitle="Produtos"
              values={produtos}
              rowId={rowId}
              quantidadeItensTotal={quantidadeItensTotal}
              rowsPerPage={rowsPerPage}
              customHandleChangePage={customHandleChancePage}
            />
          </Grid>
          <Grid item md={2} xs={12}>
            <div className="right-buttons">
              <div className="right-button">
                <Button
                  key="sincronizarProdutos"
                  color="primary"
                  variant="contained"
                  className="width-100"
                  disabled={selected.length === 0}
                  onClick={func_btn_sincronizar}
                >
                  Sincronizar Produtos
                </Button>
              </div>
              <div className="right-button">
                <Button
                  key="AtualizarEstoque"
                  color="primary"
                  variant="contained"
                  className="width-100"
                  disabled={selected.length === 0}
                  onClick={func_btn_atualizar}
                >
                  Atualizar Produto
                </Button>
              </div>
              <div className="right-button">
                <Button
                  key="VincularProduto"
                  color="primary"
                  variant="contained"
                  className="width-100"
                  disabled={vincularProdutoDisable}
                  onClick={() => {
                    setAtivarVincular(true);
                  }}
                >
                  Vincular produto
                </Button>
              </div>
              <div className="right-button">
                <Button
                  key="ExcluirAnuncio"
                  color="primary"
                  // Altera a cor do background (vermelho), caso tenha algo selecionado no grid
                  style={{
                    backgroundColor: selected.length === 0 ? null : colorRed,
                  }}
                  variant="contained"
                  className="width-100"
                  disabled={selected.length === 0}
                  onClick={func_btn_excluir_anuncio}
                >
                  Excluir Anúncio
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default MarketplacesTabProdutos;
